import React, { Component } from "react";
//import { Link, withRouter } from "react-router-dom";

import { connect } from "react-redux";
import { openModal } from "../../actions/modalAction";
import { getUserForAuth } from "../../actions/authAction";
import { logoutUser } from "../functions/Functions";
import NavMobile from "./NavMobile";
import NavDesktop from "./NavDesktop";

// import {  
//   //Button, 
//   // Image,
//  // Modal,
//   Icon,
//   } from "semantic-ui-react";

class Navbar extends Component {
  componentDidMount(){
    if (this.props.auth.isAuthenticated && !this.props.auth.userA) {
      this.props.getUserForAuth();
    }
  }
  //*********************** */
  onLogoutClick = () => {
    // this.props.history.push("/");
    this.props.logoutUser();
  };


    //@@@ 
  render() {
    
    const { isAuthenticated,user  } = this.props.auth !== undefined && this.props.auth !== null && this.props.auth;
    const userA=this.props.userA !== undefined && this.props.userA !== null && this.props.userA

    const authLinks = (
      <div>      
      <NavMobile 
      onLogoutClick={this.onLogoutClick} 
      openModal={this.props.openModal}
      userA={userA}
      user={user}
      isAuthenticated={isAuthenticated}
      />
      <NavDesktop
      onLogoutClick={this.onLogoutClick}
      openModal={this.props.openModal}
      userA={userA} 
      user={user}
      isAuthenticated={isAuthenticated}
      />
        
</div>
 );
    return (
      <div>
        {
          authLinks
        }
      </div>
    );
  }
}
//@@@@@@@@@@@@@@@@@



const mapStateToProps = state => ({
  state,
  auth: state.auth,
  visible: state.auth.visible,
  visibleBB: state.auth.visibleBB,
  userA: state.auth.userA,
});

export default connect(
  mapStateToProps,
  { openModal,getUserForAuth,logoutUser}
)(Navbar);
